import { Outlet } from 'react-router-dom';
import { GlobalProgressBar } from '@/components/feedback/GlobalProgressBar';
import { useIsBlockingLoad } from '@/hooks/useQueryActivity';
import { AuthGate } from './AuthGate';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export function Shell() {
  const busy = useIsBlockingLoad();

  return (
    <AuthGate>
      <GlobalProgressBar />
      <div className="flex h-screen w-full">
        <Sidebar />
        <div className="flex min-w-0 flex-1 flex-col">
          <Topbar />
          <main className="flex-1 overflow-auto p-6 scrollbar-thin" aria-busy={busy}>
            <Outlet />
          </main>
        </div>
      </div>
    </AuthGate>
  );
}
